import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmp8hdrknp: FaireProductEntity = {
  token: "p_vmp8hdrknp",
  type: "product",
  name: 'Wood Altar Table 12" round Wheel of the Year With Pentagram',
  brandToken: "b_pfe5z89pnk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7d23ae2f18d92befc5d634f4f1fe129f970efafd43e72441767b81b600dec0dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a329c813fc5e9fcfaa8166e1c861ec075f9249e35537c4d9ec0d2035bfa459e9.jpeg",
    "https://cdn.faire.com/fastly/52cc6ea3ba359591e3c088cdfe083ec48485eb889a00096a30003ed446ca173c.jpeg",
    "https://cdn.faire.com/fastly/26552dd0494b7f68939ede7fcbd4b7063fc86b9c6cfb1b96fbe26148d7faa976.jpeg",
    "https://cdn.faire.com/fastly/3897c6d629432f631cd4c2ae4f76725a87695852e5e708936569f428dd2ae34c.jpeg",
  ],
  priceDollars: 13.85,
  description:
    "- 12 inch diameter\n- Wheel of the year with the Pentacle in middle.\n- Altar Table\n- Hand carved impeccably in India.",
  tags: [],
  msrpDollars: 27.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:44.819Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
